import { Link } from "react-router-dom";

export default function MHFooter() {
  const scroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer style={{ backgroundColor: "#0D0D0D" }} className="pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/2f500271175ac97b037b5e94d69334e6/d3f566fff327433480db44ef3a925506.png"
              alt="Meet Hiszpania"
              className="h-14 w-auto mb-4"
            />
            <p className="text-sm text-gray-500 leading-relaxed max-w-xs mb-5">
              Platforma B2B dla polskiej branży turystycznej. Łączymy agencje z najlepszymi partnerami w Hiszpanii.
            </p>
            <div className="flex flex-col gap-2">
              <a href="mailto:info@hiszpaniadeluxe.com" className="text-sm text-gray-400 hover:text-white transition-colors">
                info@hiszpaniadeluxe.com
              </a>
              <a href="tel:+48728958974" className="text-sm text-gray-400 hover:text-white transition-colors">
                +48 728 958 974
              </a>
            </div>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-5">Nawigacja</p>
            <ul className="flex flex-col gap-3">
              {[
                { label: "O projekcie", href: "#about" },
                { label: "Partnerzy", href: "#partners" },
                { label: "Wydarzenia B2B", href: "#events" },
                { label: "Kontakt", href: "#contact" },
              ].map((s) => (
                <li key={s.label}>
                  <button onClick={() => scroll(s.href)}
                    className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                    {s.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-gray-500 mb-5">Partnerzy</p>
            <ul className="flex flex-col gap-3">
              {[
                { name: "Hotel Jardín Tecina", route: "/hotel-jardin-tecina" },
                { name: "Playitas Resort", route: "/playitas" },
              ].map((p) => (
                <li key={p.name}>
                  <Link to={p.route} className="text-sm text-gray-400 hover:text-white transition-colors">
                    {p.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t pt-8 flex flex-col md:flex-row items-center justify-between gap-4" style={{ borderColor: "#1a1a1a" }}>
          <p className="text-xs text-gray-600">
            © {new Date().getFullYear()} Meet Hiszpania / Hiszpania de Luxe. Wszelkie prawa zastrzeżone.
          </p>
          <p className="text-xs text-gray-600">meethiszpania.com</p>
        </div>
      </div>
    </footer>
  );
}
